export const CONTACT_API = '/email/contact/send';
